import styled from 'styled-components';

/**
 * Outer wrapper for the dialog body. Gives the embedded
 * {@link RunConfigForm} a sensible minimum width so it doesn't collapse
 * on narrow viewports.
 */
export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 360px;
`;
